import { AssetType, type Link, type Suite } from "#gen/bundles/v1/bundle_pb.js";
import type { DragEndEvent as AbstractDragEndEvent, DragMoveEvent as AbstractDragMoveEvent, DragOverEvent as AbstractDragOverEvent, DragStartEvent as AbstractDragStartEvent } from "@dnd-kit/abstract";
import type { DragDropManager, Draggable, Droppable } from "@dnd-kit/dom";

export type DragStartEvent = AbstractDragStartEvent<Draggable, Droppable, DragDropManager>;
export type DragOverEvent = AbstractDragOverEvent<Draggable, Droppable, DragDropManager>;
export type DragEndEvent = AbstractDragEndEvent<Draggable, Droppable, DragDropManager>;
export type DragMoveEvent = AbstractDragMoveEvent<Draggable, Droppable, DragDropManager>;

export const NON_INLINEABLE_ASSET_TYPES = new Set([AssetType.UNSPECIFIED, AssetType.EXTERNAL_DESTINATION, AssetType.STATIC_ASSET, AssetType.LANDING_PAGE, AssetType.PAGE_CONTAINER]);
export const ONLY_INLINEABLE_ASSET_TYPES = new Set([AssetType.AD_UNIT]);

export type BundleValidationErrors = Record<string, Record<string, string>>;

export interface ModuleManagerEvents {
	onClick?: (suite: Suite, link: Link) => void;
	onSelect?: (suite: Suite, link: Link) => void;
	onToggle?: (suite: Suite, link: Link) => void;
	onChange?: (suite: Suite, link: Link) => void;
	onInput?: (suite: Suite, link: Link) => void;
	onRemove?: (suite: Suite, link: Link) => void;
}

export function makeLinkId(link: Link): string {
	return `${link.source}:${link.sourceAnchor}:${link.destination}:${link.destinationAnchor}`;
}

export function move<T>(arr: T[], fromIndex: number, toIndex: number) {
	while (fromIndex < 0) {
		fromIndex += arr.length;
	}
	while (toIndex < 0) {
		toIndex += arr.length;
	}
	const element = arr.splice(fromIndex, 1)[0];
	arr.splice(toIndex, 0, element);
	return arr;
}
